import Redirect from 'react-router/lib/Redirect';


export default function doRedirect(router, to, params, query) {
    if (typeof window === 'undefined') {
        throw new Redirect(to, params, query);
    } else {
        setTimeout(() => {
            router.transitionTo(to, params, query);
        }, 50);
    }
}


/** WEBPACK FOOTER **
 ** ./app/src/utils/doRedirect.js
 **/